import ApiService from '@/services/core/api.service'

const BorrowingHistoryService = {

  async getBorrowings (query = '') {
    return ApiService.get(`user/borrowing-histories/borrowings?${query}`)
  },

  async getBorrowingItems (query = '') {
    return ApiService.get(`user/borrowing-histories/items?${query}`)
  },

  async getBorrowingItemDetails (query = '') {
    return ApiService.get(`user/borrowing-histories/item-details?${query}`)
  }

}

export default BorrowingHistoryService
